<template>
  <div>
    <JqxWindow ref="myWindow" :theme="'material'" :width="930" :height="650" :resizable="true" :isModal="true"
               :autoOpen="false" :initContent="init">
      <div class="col-md"><strong>Scheda UDC</strong>
      </div>
      <div>
        <JqxTabs ref="tab" :theme="'material'" :animationType="'fade'" :autoCreate="false">
          <ul id="muoviti" style="margin-left: 5px">
            <li>Dati generali</li>
            <li>Extra</li>
          </ul>
          <div>
            <JqxSplitter ref="splitter" :width="850" :heigth="600" :autoCreate="false" :panels="panels">
              <div class="splitter-panel" :theme="'material'">
                <div style="margin-top: 5px;margin-left: 5px;">
                  <div class="form-group">
                    <label>Numero ingresso</label>
                    <br>
                    <JqxInput :theme="'material'" ref="numero_ingresso"></JqxInput>
                  </div>
                  <div class="form-group">
                    <label>DDT Fornitore</label>
                    <br>
                    <JqxInput :theme="'material'" ref="documento_fornitore"></JqxInput>
                  </div>
                  <div class="form-group">
                    <label>Articolo</label>
                    <br>
                    <JqxInput :theme="'material'" ref="articolo"></JqxInput>
                  </div>
                  <div class="form-group">
                    <label>Quantita</label>
                    <br>
                    <JqxInput :theme="'material'" ref="quantita_caricata"></JqxInput>
                  </div>
                  <div class="form-group">
                    <label>Ubicazione</label>
                    <br>
                    <JqxInput :theme="'material'" ref="ubicazione"></JqxInput>
                  </div>
                  <div class="form-group">
                    <label>Data arrivo merce</label>
                    <br>
                    <JqxInput :theme="'material'" ref="data_arrivo_merce"></JqxInput>
                  </div>
                </div>
              </div>
              <div class="splitter-panel">
                <div style="margin-top: 5px;margin-left: 5px;">
                  <div class="form-group">
                    <label>Riga ingresso</label>
                    <br>
                    <JqxInput :theme="'material'" ref="riga_ingresso"></JqxInput>
                  </div>
                  <div class="form-group">
                    <label>Descrizione articolo</label>
                    <br>
                    <JqxInput :theme="'material'" ref="descrizione_articolo"></JqxInput>
                  </div>
                  <div class="form-group">
                    <label>Lotto</label>
                    <br>
                    <JqxInput :theme="'material'" ref="lotto"></JqxInput>
                  </div>
                </div>
              </div>
            </JqxSplitter>
          </div>
          <div>
            <div class="form-group">
              <label>Note interne</label>
              <br>
              <JqxInput :theme="'material'" ref="note_interne"></JqxInput>
            </div>
          </div>
        </JqxTabs>
        <card>
          <div class="float-right">
            <!--<JqxButton :theme="'material'" @click="saveParent">
              Save
            </JqxButton>-->
            <JqxButton :theme="'material'" @click="cancelParent">
              Cancel
            </JqxButton>
          </div>
        </card>
      </div>
    </JqxWindow>
  </div>

</template>

<script>
  import JqxWindow from "~jqx/jqwidgets-vue/vue_jqxwindow.vue";
  import JqxButton from "~jqx/jqwidgets-vue/vue_jqxbuttons.vue";
  import JqxInput from "~jqx/jqwidgets-vue/vue_jqxinput.vue";
  import JqxNumberInput from "~jqx/jqwidgets-vue/vue_jqxnumberinput.vue";
  import JqxSplitter from '~jqx/jqwidgets-vue/vue_jqxsplitter.vue';
  import JqxTabs from '~jqx/jqwidgets-vue/vue_jqxtabs.vue';
  import JqxComboBox from "~jqx/jqwidgets-vue/vue_jqxcombobox.vue";
  import JqxCheckBox from "~jqx/jqwidgets-vue/vue_jqxcheckbox.vue";

  export default {
    name: "GiacenzeDetails",
    components: {
      JqxInput,
      JqxNumberInput,
      JqxButton,
      JqxWindow,
      JqxSplitter,
      JqxTabs,
      JqxComboBox,
      JqxCheckBox

    },
    data: function () {
      return {
        panels: [{size: 200}, {size: 200}],
        //dataAdapterTipoDocumenti: new jqx.dataAdapter(this.sourcetipodocumenti),
       // dataAdapterTipopicking: new jqx.dataAdapter(this.sourcetipopicking)
      }
    },
    /*beforeCreate: function () {
      this.sourcetipodocumenti = {
        datatype: 'json',
        datafields: [
          {name: 'descrizione'},
          {name: 'id'},
        ],
        url: '/api/cruds/read?t=AnagraficaTipoDocumenti&q=allforsourceinput'
      };
      this.sourcetipopicking = {
        datatype: 'json',
        datafields: [
          {name: 'descrizione'},
          {name: 'id'},
        ],
        url: '/api/cruds/read?t=AnagraficaTipoPicking&q=allforsourceinput'
      };
    },*/
    methods: {
      saveParent() {
        this.$parent.saveBtn();
      },
      init: function () {
        let options = {height: "80%", theme: "material"};
        this.$refs.tab.createComponent(options);
        //this.$refs.splitter.panels =[{ size: 400 },{ size: 400 }];
        let tmp = {width: "98%", height: "98%", theme: "material"};
        this.$refs.splitter.createComponent(tmp);
      },
      cancelParent() {
        this.$parent.cancelBtn();
      },
    },
    mounted: function () {

    }
  }
</script>

<style scoped>
  .jqx-splitter {
    border: none;
  }
</style>
